import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject, throwError } from "rxjs";
import { catchError, takeUntil } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { StatsRequest } from "../models/stats-request";
import {APIResponse} from "../models/Response";
import {GetStatsV3ResponseWithTask, StatsApiResponse} from "../models/stats-response";
import {OrgBuProjectTeamsResponse} from "../models/custom-models/org-buproject-team-structure";

@Injectable({
    providedIn: "root",
})
export class StatsService {
    apiServerUrl = environment.apiBaseUrl;
    private cancelPendingRequests$ = new Subject<void>();

    constructor(private http: HttpClient) {}

    cancelPendingRequests() {
        this.cancelPendingRequests$.next();
    }

    //  get the statsV3
    getStatsV3(statsRequest: StatsRequest, accountIds?:string): Observable<APIResponse<StatsApiResponse>> {
        return this.http.post<APIResponse<StatsApiResponse>>(`${this.apiServerUrl}/stats/getStatsV3`, statsRequest, {
            headers: {
                accountIds: accountIds || ""
            }
        }).pipe(
            takeUntil(this.cancelPendingRequests$),
            catchError((error) => {
                return throwError(error);
            }),
        );
    }

    //  get task Status details
    getStatusTaskDetails(statusName: string, statsRequest: StatsRequest): Observable<any> {
        return this.http.post(`${this.apiServerUrl}/task/getAllTaskStatusDetails/${statusName}`, statsRequest).pipe(
            catchError((error) => {
                return throwError(error);
            }),
        );
    }

    //  get all org, BU, project, team hierarchy of a user
    getOrgTeamDropdownStructure(userName: string): Observable<any> {
        return this.http.get(`${this.apiServerUrl}/user/getOrgTeamDropdownStructure/${userName}`).pipe(
            catchError((error) => {
                return throwError(error);
            }),
        );
    }

    getOrgTeamDropdownStructureV2(userName: string, screenName:string=""): Observable<APIResponse<OrgBuProjectTeamsResponse>> {
        return this.http.get<APIResponse<OrgBuProjectTeamsResponse>>(`${this.apiServerUrl}/user/getUserAllOrgAccess/${userName}`, {
            headers: {
                screenName: screenName
            }
        }).pipe(
            catchError((error) => {
                return throwError(error);
            }),
        );
    }

    //  get task details for the given status with filters or without filters
    getFilteredTaskOfTeam(statsRequest: StatsRequest, pageNumber:number, pageSize:number): Observable<APIResponse<GetStatsV3ResponseWithTask>> {
        return this.http.post<APIResponse<GetStatsV3ResponseWithTask>>(`${this.apiServerUrl}/stats/getStatsV3?pageNumber=${pageNumber}&pageSize=${pageSize}`, statsRequest).pipe(
            catchError((error) => {
                return throwError(error);
            }),
        );
    }
}
